import {FC} from 'react'
import {useTranslation} from '@/translations/i18n'
import {StyledCard} from './style'
import {AvatarGroup} from '@/components/commons/avatar-group/AvatarGroup'
import {GroupActionsMenu} from '../group-actions-menu/GroupActionsMenu'
import {formatLocaleDate} from '@/dayjs'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {UserGroup} from '@/features/user-groups/types'
import {usePermissions} from '@/features/auth/store/store'

interface UserGroupCardProps {
    group: UserGroup
    onEdit: (group: UserGroup) => void
    onDelete: (group: UserGroup) => void
}

export const UserGroupCard: FC<UserGroupCardProps> = ({group, onEdit, onDelete}) => {
    const {t} = useTranslation()
    const permissions = usePermissions()
    const {name, members, createdAt} = group
    const memberCount = members.length

    return (
        <StyledCard direction="column" gap={4}>
            <Flexbox justify="space-between" align="center" fullWidth>
                <AvatarGroup>
                    {group.members.slice(0, 3).map(member => (
                        <AvatarGroup.Item
                            key={member.id}
                            name={`${member.firstName} ${member.lastName}`}
                            imageUrl={member.avatarUrl || undefined}
                        />
                    ))}
                </AvatarGroup>
                {permissions?.users?.write && <GroupActionsMenu group={group} onEdit={onEdit} onDelete={onDelete} />}
            </Flexbox>
            <Flexbox direction="column" gap={1}>
                <Text render="h3" size="textMd" weight={500} palette="neutral" shade="900">
                    {name}
                </Text>
                <Text size="textMd" palette="neutral" shade="700">
                    {t('user_groups:members_count', {count: memberCount})}
                </Text>
            </Flexbox>
            <Text size="textXs" palette="neutral" shade="500" weight={500}>
                {t('user_groups:created', {date: formatLocaleDate(createdAt, 'DD/MM/YYYY')})}
            </Text>
        </StyledCard>
    )
}
